import { render } from "./LinkedImg.vue?vue&type=template&id=ddd8f6ba&scoped=true"
import script from "./LinkedImg.vue?vue&type=script&lang=js"
export * from "./LinkedImg.vue?vue&type=script&lang=js"

import "./LinkedImg.vue?vue&type=style&index=0&id=ddd8f6ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd8f6ba"]])

export default __exports__